import(/* webpackMode: "eager" */ "/opt/build/repo/app/page.tsx")